import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 16px;
  margin: 30px auto 0 auto;

  @media (max-width: 425px) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
`;
